import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, queryIapConfig } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Select = Loadable({
    loader: () => import('./Select'),
    render(loaded, props) {
      const Component = connect((state) => ({
        paymentsSelectState: state.paymentsSelectState,
        siteConfig: state.siteConfig
      }), {
        init,
        queryIapConfig
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/select`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Select {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
